export default {
  setProperty(state, { property, payload }) {
    state[property] = payload;
  },

  setNewPaymentMethod(state, { payload }) {
    state.payment_methods = [...state.payment_methods, ...[payload]];
  },

  delProperty(state, { property }) {
    state.payment_methods = state.payment_methods.filter(el => el.id !== property);
  },
};
